import React, { Component} from 'react'
import { BrowserRouter as Router, Route, Routes } from "react-router-dom"
import PageLoading from './PageLoading';
import PageNotFound from './PageNotFoundComponent';

class Main extends Component {

  // eslint-disable-next-line no-useless-constructor
  constructor(props) {
    super(props);
  }

  render() {

    const HomePage = () => {
      setTimeout(() => {
          window.location = 'home.html'
      }, 2000)

      return (<PageLoading />);
    }

    return (
      <>
        <Router>
          <Routes>
            <Route exact path="/" element={<HomePage />} />
            <Route exact path="/home" element={<HomePage />} />
            <Route path="*" element={<PageNotFound />} />
          </Routes>
        </Router>
      </>
    )
  }
}

export default Main;